// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroWorkCardHeader-cls1_AQN","cls2":"HeroWorkCardHeader-cls2_lD5 HeroWorkCardHeader-cls1_AQN"};